export default __webpack_public_path__ + "static/media/02_1_overview-SOWs.6cffb095.png";